<router-outlet></router-outlet>

<p-dialog [(visible)]="showIdle" [modal]="true" styleClass="p-fluid modalIdle" [closable]="false">
    <h1>{{idleState}}</h1>
</p-dialog>